import {Component, EventEmitter, inject, Input, Output, signal, WritableSignal} from '@angular/core';
import {ColDef, GetRowIdParams, GridApi, GridOptions} from 'ag-grid-community';
import {IClientMessageDetails} from './client-message-details.interface';
import {MatButton} from '@angular/material/button';
import {AgGridModule} from 'ag-grid-angular';
import {AG_GRID_GERMAN_LOCALE} from "frontier";
import {DynamicTooltipService} from "../../../../../../Services/dynamic-tooltip.service";

@Component({
  selector: 'app-client-message-details',
  templateUrl: './client-message-details.component.html',
  styleUrl: './client-message-details.component.scss',
  standalone: true,
  imports: [AgGridModule, MatButton]
})
export class ClientMessageDetailsComponent {
  rowData: WritableSignal<any[]> = signal(undefined);
  actionDescription: WritableSignal<string> = signal('');
  documentAssigned: WritableSignal<boolean> = signal(false);
  displayAction: WritableSignal<boolean> = signal(false);
  gridApi: GridApi<any>;

  dynamicTooltipService: DynamicTooltipService = inject(DynamicTooltipService);

  @Input() set messageData(data: IClientMessageDetails) {
    if (!data) return;
    this.rowData.set(data.rows);
    this.actionDescription.set(data.actionDescription);
    this.documentAssigned.set(data.documentAssigned);
    this.displayAction.set(data.displayAction);
  };

  @Output() resolveAutomatically = new EventEmitter();
  @Output() resolveManually = new EventEmitter();
  @Output() showDocument = new EventEmitter();

  gridOptions: GridOptions<any> = {
    localeText: AG_GRID_GERMAN_LOCALE,
    rowHeight: 30,
    headerHeight: 0,
    onGridReady: (event) => event.api.sizeColumnsToFit(),
    getRowId: (params: GetRowIdParams) => params.data.label,
  };

  @Input() colDefs: ColDef[];

  onResolveAutomatically() {
    this.resolveAutomatically.emit()
  }

  onResolveManually() {
    this.resolveManually.emit()
  }

  onShowDocument() {
    this.showDocument.emit()
  }
}
